/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Filters_CompletedInputs */

const id_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai`)
};

const ms_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap`)
};

const da_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuldførte`)
};

const de_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

const en_us2_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const es_es2_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completados`)
};

const es_mx2_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completados`)
};

const fil_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natapos`)
};

const fr_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminés`)
};

const it_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completati`)
};

const hu_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítve`)
};

const nl_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltooid`)
};

const no_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullført`)
};

const pl_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukończone`)
};

const pt_br2_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

const pt_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completos`)
};

const ro_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizate`)
};

const fi_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmiit`)
};

const sv_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutförda`)
};

const vi_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hoàn thành`)
};

const tr_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlanan`)
};

const cs_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončené`)
};

const bg_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завършени`)
};

const ru_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пройденные`)
};

const uk_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершені`)
};

const ar_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكتملة`)
};

const hi_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण`)
};

const th_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมบูรณ์`)
};

const ja_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const zh_cn2_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const zh_hant1_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const ko_profile_library_filters_completed = /** @type {(inputs: Profile_Library_Filters_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Profile_Library_Filters_CompletedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_filters_completed = /** @type {((inputs?: Profile_Library_Filters_CompletedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Filters_CompletedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_filters_completed(inputs)
	if (locale === "ms") return ms_profile_library_filters_completed(inputs)
	if (locale === "da") return da_profile_library_filters_completed(inputs)
	if (locale === "de") return de_profile_library_filters_completed(inputs)
	if (locale === "en-US") return en_us2_profile_library_filters_completed(inputs)
	if (locale === "es-ES") return es_es2_profile_library_filters_completed(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_filters_completed(inputs)
	if (locale === "fil") return fil_profile_library_filters_completed(inputs)
	if (locale === "fr") return fr_profile_library_filters_completed(inputs)
	if (locale === "it") return it_profile_library_filters_completed(inputs)
	if (locale === "hu") return hu_profile_library_filters_completed(inputs)
	if (locale === "nl") return nl_profile_library_filters_completed(inputs)
	if (locale === "no") return no_profile_library_filters_completed(inputs)
	if (locale === "pl") return pl_profile_library_filters_completed(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_filters_completed(inputs)
	if (locale === "pt") return pt_profile_library_filters_completed(inputs)
	if (locale === "ro") return ro_profile_library_filters_completed(inputs)
	if (locale === "fi") return fi_profile_library_filters_completed(inputs)
	if (locale === "sv") return sv_profile_library_filters_completed(inputs)
	if (locale === "vi") return vi_profile_library_filters_completed(inputs)
	if (locale === "tr") return tr_profile_library_filters_completed(inputs)
	if (locale === "cs") return cs_profile_library_filters_completed(inputs)
	if (locale === "bg") return bg_profile_library_filters_completed(inputs)
	if (locale === "ru") return ru_profile_library_filters_completed(inputs)
	if (locale === "uk") return uk_profile_library_filters_completed(inputs)
	if (locale === "ar") return ar_profile_library_filters_completed(inputs)
	if (locale === "hi") return hi_profile_library_filters_completed(inputs)
	if (locale === "th") return th_profile_library_filters_completed(inputs)
	if (locale === "ja") return ja_profile_library_filters_completed(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_filters_completed(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_filters_completed(inputs)
	return ko_profile_library_filters_completed(inputs)
});
export { profile_library_filters_completed as "profile.library.filters.completed" }